import { Injectable, OnInit } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { ImageData } from '../../shared/model/api/image-data';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ViewConstants } from '../../../app/constants';
import { SharedDataService } from './../services/shared-data.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { IAppCoreState } from '../state';
import { getUserInfo } from '../state/selectors';
import { isNil } from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class ddImageDataService implements OnInit {
  public _subs = new SubSink();
  darkTheme = false;
  constructor( private readonly http: HttpClient,private readonly sharedService:SharedDataService,private readonly environment:EnvironmentConfiguration, private readonly _store: Store<IAppCoreState>) { }
  ngOnInit(): void {
    this.darkTheme = this.sharedService.getDarkThemeValue();
  }

  public get(imagesNeedingData: ImageData[], label: string): Observable<ImageData[]> {
    return Observable.create((observer: Subscriber<ImageData[]>) => {
      const imagesToProcess = imagesNeedingData.length;
      let imagesProcessed = 0;
      const completeObserver = (): void => {
        if (imagesToProcess === imagesProcessed) {
          observer.next([...imagesNeedingData]);
          observer.complete();
        }
      };
      imagesNeedingData.forEach((image: ImageData) => {
        if (!isNil(image) && !isNil(image.imageSource)) {
          // this._loadBase64DataFromImageURL(image, (imageBase64Data: string) => {
          //   if (Library.isStringWithLength(imageBase64Data)) {
          //     image.base64Data = imageBase64Data;
          //   }
          //   imagesProcessed++;
          //   completeObserver();
          // });

          this._loadBase64DataFromImageURL(null, label,
            image.imageSource, (imageBase64Data) => {
              image.base64Data = imageBase64Data;
              imagesProcessed++;
              completeObserver();
            });
        } else {
          imagesProcessed++;
          completeObserver();
        }
      });
    });
  }

  // private _loadBase64DataFromImageURL(imageData: ImageData, callback: (imageBase64Data: string) => void) {
  //   const newImg: HTMLImageElement = null;

  //   if (Library.isStringWithLength(imageData.imageSource)) {
  //     //Manually getting the image
  //     imageData.imageSource = "https://media.rti.qa.toyota.com/config/pub/static/images/TOY/2020/yaris/exteriorcolor/carjellyimage/19c1af969fcfe380a332dc51aabc34d8cc892ad39048c52d3668d41d85854f5b_MY20_Yaris_Hatchback_XLE_044J_002.png"
  //     let imgCanvas: any = document.createElement('CANVAS');
  //     const img = document.createElement('img');
  //     img.setAttribute('crossOrigin', 'Anonymous');

  //     /**
  //      * Workaround - Without this additional query string, cloudfront is giving  No 'Access-Control-Allow-Origin'
  //      * header is present on the requested resource, the same works when the cache is disabled on browser, adding this
  //      * additional query string will simulate the same disable cache for the images. This looks to be an issue on cloudfront
  //      * because the origin server is just allowing request from *.toyota.com and *.lexus.com, while most of them allow *.*
  //      */
  //     // console.log(" imageData.imageSource==> ", imageData.imageSource);

  //     img.src = imageData.imageSource ;
  //     img.onload = () => {
  //       imgCanvas.height = img.height;
  //       imgCanvas.width = img.width;
  //       const context = imgCanvas.getContext('2d');
  //       context.drawImage(img, 0, 0);
  //       const dataURL = imgCanvas.toDataURL('image/png');
  //       imgCanvas = null;
  //       if (!isNil(newImg)) {
  //         newImg.src = dataURL;
  //       }
  //       callback(dataURL);
  //     };
  //     img.onerror = () => {
  //       callback(null);
  //     };
  //   } else {
  //     callback(null);
  //   }
  // }

  _loadBase64DataFromImageURL(imageId: string, label: string, imageSrc: string, callback: Function) {
    let newImg: HTMLImageElement = null;
    if (!isNil(imageId)) {
      newImg = document.getElementById(imageId) as HTMLImageElement;
    }
    let imgCanvas: any = document.createElement('CANVAS');
    const img = document.createElement('img');
    img.setAttribute('crossOrigin', 'Anonymous');
    if (label === "monroney" || label === "detail") {
      if (!isNil(imageSrc) && imageSrc !== '') {
        img.src =  imageSrc;
        // img.src = this.environment.MST_BASE_SERVICE_URL + "/retail/image?url=" + imageSrc
      } else {
        imageSrc = this.darkTheme ? "../../../../assets/images/icon-no-image-night.png" : "../../../../assets/images/icon-no-image.png";
        img.src = imageSrc;
      }
    }
    else {
      const corsApiUrl = 'https://cors-anywhere.herokuapp.com/';


      if (!isNil(imageSrc) && imageSrc !== '') {
        img.src = corsApiUrl + imageSrc;
      } else {
        imageSrc = this.darkTheme ? "../../../../assets/images/icon-no-image-night.png" : "../../../../assets/images/icon-no-image.png";
        img.src = imageSrc;
      }
    }

    // let corsApiUrl = 'https://cryptic-headland-94862.herokuapp.com/';

    // Workaround - Without this additional query string, cloudfront is giving  No 'Access-Control-Allow-Origin'
    // header is present on the requested resource, the same works when the cache is disabled on browser, adding this
    // Additional Query string will simulate the same disable cache for the images. This looks to be an issue on cloudfront
    // Because the origin server is just allowing request from *.toyota.com and *.lexus.com, while most of them allow *.*


    //img.src =  imageSrc + '?x-request=vspec';

    img.onload = () => {
      imgCanvas.height = img.height;
      imgCanvas.width = img.width;
      const context = imgCanvas.getContext('2d');
      context.drawImage(img, 0, 0);
      const dataURL =  imgCanvas.toDataURL('image/png');
      imgCanvas = null;
      if (!isNil(newImg)) {
        newImg.src = dataURL;
      }
      callback(dataURL);
    };
    img.onerror = () => {
      callback(null);
    };
    // } 
    // else {
    //   callback(null);
    // }
  }

  loadImages(imageUrl) {
    return new Promise((resolve, reject) => {

      // let authenticateRequestHeaders = new Headers();
      // this.tessLoginService.renewToken().then(success => {
        let token;
        this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
          if(userInfo?.hasOwnProperty('isIdToken')) {
            if(userInfo.isIdToken.toLowerCase() == 'true'.toLowerCase()) {
              token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ID_TOKEN_HTTP_CLIENT);
            } else if(userInfo.isIdToken.toLowerCase() == 'false'.toLowerCase()) {
              token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
            }
          }
        });
        const headers = new HttpHeaders().set('Authorization',  token);

        this.http.get(`${this.environment.MST_BASE_SERVICE_URL  }retail/image?url=${  imageUrl}`, { headers: headers, observe: 'response' })
          .pipe(
            timeout(30000),
            map((res: any) => {
              return { status: res.status, json: res.body };
            }),
            catchError((res: any) => {
              if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf('timeout') > -1)) {
                return of('timeout');
              } else {
                return of(res);
              }
            })
          )
          .subscribe(data => {
            if (data === 'timeout') {
              resolve(null);
            } else if (data == null || data === undefined) {
              resolve(null);
            } else {
              if (data.hasOwnProperty('status') && data.status === 200) {
                resolve(data.json.image);
              }
              else {
                  resolve(null);
              }
            }
          }, error => {
            resolve(null);
          });
      });
  }
}
